import type { Dayjs } from "dayjs";

import { isDurationLessThanGranularity } from "app/components/campaigns/shared/utils";
import { GranularityNames } from "app/UtilitiesAndConstants/Constants/Moment";

import { REPORT_GRANULARITY_OPTIONS } from "../constants";
import type { GranularityItem } from "../types";

type OverviewDatesRange = { from: Dayjs; to: Dayjs };

export const getUpdatedGranularityItemsState = (durationObject: OverviewDatesRange): GranularityItem[] => {
    return REPORT_GRANULARITY_OPTIONS.map((item) => {
        let disabled = false;
        let tooltipText: string | undefined;

        if (item.value === GranularityNames.WEEKLY || item.value === GranularityNames.MONTHLY) {
            disabled = isDurationLessThanGranularity(durationObject, item.value);
            if (disabled) {
                tooltipText =
                    item.value === GranularityNames.WEEKLY
                        ? "RT.granularity.disabled.weeklyDateRange"
                        : "RT.granularity.disabled.monthlyDateRange";
            }
        }
        return { ...item, disabled, tooltipText };
    });
};
